export default {
    data() {
        return {
            isTouch: false,
            touchStartedX: 0,
            currentXDiff: 0,
        }
    },
    methods: {
        onSwipeEnd() {},
        onTouchStart(e) {
            this.isTouch = true
            this.touchStartedX = e.touches[0].clientX
        },
        onTouchMove(e) {
            this.currentXDiff = e.touches[0].clientX - this.touchStartedX

            if (Math.abs(this.currentXDiff) > 10) {
                e.preventDefault()
            }
        },
        onTouchEnd() {
            this.onSwipeEnd(this.currentXDiff)
            this.touchStartedX = 0
            this.currentXDiff = 0
            this.isTouch = false
        },
    },
}
